import { createContext, useContext } from 'react';

/**
 * Which card should glow right now (hovering a "depends on" chip on another tile sets it).
 * Lives in context so tiles deep in the column tree don't need the state threaded through.
 */
export interface HighlightState {
  highlightedCardId: number | null;
  setHighlightedCardId: (id: number | null) => void;
}

export const HighlightContext = createContext<HighlightState>({
  highlightedCardId: null,
  setHighlightedCardId: () => {},
});

export const useHighlight = () => useContext(HighlightContext);
